"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveEditingStatus = void 0;
var react_1 = __importDefault(require("react"));
var Text_1 = require("office-ui-fabric-react/lib/Text");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/live-editing-status.scss");
var EDITING_STATUS_ICON_NAME = 'NetworkTower';
var CONCURRENT_EDITING_MESSAGE = 'If someone else is editing and saves first, your changes may not be saved and a reload may be required.';
/**
 * LiveEditingStatus - Shows live editing presence, warning info, and editor avatars.
 */
exports.LiveEditingStatus = function (_a) {
    var _b = _a.editors, editors = _b === void 0 ? [] : _b;
    var isEditing = editors.length > 0;
    var statusText = isEditing
        ? editors.length + " " + (editors.length === 1 ? 'person' : 'people') + " editing"
        : 'No one editing';
    var firstEditor = editors[0];
    var hasAdditionalEditors = editors.length > 1;
    return (react_1.default.createElement("div", { "aria-live": "polite", className: "ws-live-editing-status" },
        react_1.default.createElement("div", { className: "ws-live-editing-icon-column" },
            react_1.default.createElement(Icon_1.Icon, { iconName: EDITING_STATUS_ICON_NAME, className: "ws-live-editing-icon" })),
        react_1.default.createElement("div", { className: "ws-live-editing-message-column" },
            react_1.default.createElement("div", { className: "ws-live-editing-text-row" },
                react_1.default.createElement(Text_1.Text, { variant: "small", className: "ws-live-editing-text" }, statusText),
                isEditing && (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: CONCURRENT_EDITING_MESSAGE, calloutProps: { gapSpace: 6 } },
                    react_1.default.createElement(Icon_1.Icon, { iconName: "Info", className: "ws-live-editing-info-icon" })))),
            react_1.default.createElement("div", { "aria-hidden": "true", className: "ws-live-editing-line-track" },
                react_1.default.createElement("div", { className: "ws-live-editing-line" + (isEditing ? ' ws-live-editing-line-active' : ' ws-live-editing-line-inactive') }))),
        isEditing && firstEditor && (react_1.default.createElement("div", { className: "ws-live-editing-users-column" },
            react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: react_1.default.createElement("div", { className: "ws-live-editing-tooltip-content" }, editors.map(function (editor) { return (react_1.default.createElement("div", { key: editor.id, className: "ws-live-editing-tooltip-person" },
                    react_1.default.createElement("div", null, editor.email))); })), calloutProps: { gapSpace: 6 } },
                react_1.default.createElement("div", { className: "ws-live-editing-users-stack" },
                    react_1.default.createElement("div", { className: "ws-live-editing-primary-avatar" }, firstEditor.email.charAt(0).toUpperCase()),
                    hasAdditionalEditors && (react_1.default.createElement("div", { className: "ws-live-editing-secondary-avatar" },
                        "+",
                        editors.length - 1))))))));
};
